import '@wix/design-system/styles-default.global.css';
import {
  getSearchParams,
  PackagePickerEssentialsProvider,
  wixServerData,
} from '@wix/package-picker-shared';
import {
  HeaderFooterProvider,
  ModuleProvider,
  useAnonymous,
} from '@wix/package-picker-shared-studio';
import { Trans } from '@wix/wix-i18n-config';
import React from 'react';
import ReactDOM from 'react-dom';
import { StudioPackagePickerModule } from './modules/studio-package-picker.module';

const SENTRY_DSN =
  'https://e7be84a65101f6e95b3970c602889d73@o37417.ingest.us.sentry.io/4510386381651973';

const StudioApplication = () => {
  const { locale, userId } = wixServerData.get();
  const { siteGuid } = getSearchParams();
  const { isAnonymous } = useAnonymous();

  React.useEffect(() => {
    HeaderFooterProvider({
      locale,
      brand: 'studio',
      isAnonymous,
    });
  }, []);

  return (
    <PackagePickerEssentialsProvider
      siteGuid={siteGuid}
      artifactId="package-picker-studio"
      version="1.0.0"
      Trans={Trans}
      componentId="package-picker-studio"
      sentryDsn={SENTRY_DSN}
      userId={userId}
      locale={locale}
    >
      <ModuleProvider module={StudioPackagePickerModule}>
        <StudioPackagePickerModule.Provider translations={{ Loading: <></> }}>
          <StudioPackagePickerModule.SDK.Application />
        </StudioPackagePickerModule.Provider>
      </ModuleProvider>
    </PackagePickerEssentialsProvider>
  );
};

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<StudioApplication />, document.getElementById('root'));
